import { CHECK_ORDER } from './check_order';
import { Filters } from '../../_flux/constants/filter/filters';
import { getDefaultValueForFilter } from '../../_flux/helper/filters/get_default_value_for_filter';
import RegoLookupStore from '../../_flux/stores/rego_lookup_store';
import { resetFiltersAfterFilter } from './reset_filters_after_change';
export function checkNextEmptyValueAvailable(changedFilter) {
    const changedIndexInCheckOrder = CHECK_ORDER.indexOf(changedFilter);

    if (changedIndexInCheckOrder === -1) {
        return;
    }

    const regoLookupFilterValues = RegoLookupStore.getState().values;
    let nextToCheck;
    let selectedFilterValues = {};
    let changedFilterDefaultValue;
    // get the next logical input's name
    for (let i = changedIndexInCheckOrder + 1; i < CHECK_ORDER.length; ++i) {
        changedFilterDefaultValue = getDefaultValueForFilter(CHECK_ORDER[i]);
        if (regoLookupFilterValues[CHECK_ORDER[i]] === changedFilterDefaultValue
        ) {
            nextToCheck = CHECK_ORDER[i];
            break;
        }
    }

    // get all the values of input which have been selected already
    for (let i = 0; i < CHECK_ORDER.length; ++i) {
        changedFilterDefaultValue = getDefaultValueForFilter(CHECK_ORDER[i]);
        if (regoLookupFilterValues[CHECK_ORDER[i]] !== changedFilterDefaultValue) {
            selectedFilterValues[CHECK_ORDER[i]] = regoLookupFilterValues[CHECK_ORDER[i]];
        }
    }

    if (nextToCheck) {
        resetFiltersAfterFilter(changedFilter);
    }
}
